import { Navigate } from 'react-router-dom';
// import { useIsOnboardedDriver } from '../hooks/useIsOnboardedDriver';
// import { useIsInvalidInternalUser } from '../hooks/useIsInvalidInternalUser';
import authService from '../services/authService';

function PrivateRoute({ children }: React.PropsWithChildren): any {
  // const isInvalidInternalUser = useIsInvalidInternalUser();
  // const isOnboardedDriver = useIsOnboardedDriver();

  // if (isInvalidInternalUser) {
  //   return <Navigate to="/noaccess" replace />;
  // }

  // if (isOnboardedDriver) {
  //   authService.logout();
  //   window.location.href = 'https://bolt.americanlogistics.com';
  // }

  return authService.isLoggedIn() ? (
    children
  ) : (
    <Navigate
      to={`/internallogin?returnPage=${window.location.pathname}${window.location.search}`}
    />
  );
}

export default PrivateRoute;
